'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosArrowThinDown = function IoIosArrowThinDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.3 25.2c0.2 0.1 0.2 0.3 0.2 0.4s0 0.3-0.2 0.5c0 0-6.8 6.2-6.8 6.2s-0.3 0.2-0.5 0.2-0.4-0.1-0.5-0.2-6.8-6.2-6.8-6.2c-0.3-0.2-0.3-0.7 0-0.9s0.7-0.3 0.9 0l5.8 5.2v-22.3c0-0.3 0.3-0.6 0.6-0.6s0.6 0.3 0.6 0.6v22.3l5.8-5.2c0.2-0.3 0.7-0.3 0.9 0z' })
        )
    );
};

exports.default = IoIosArrowThinDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-arrow-thin-down.js
// module id = 2303
// module chunks = 0